/* eslint-disable */
$.fn.andSelf = function () {
  return this.addBack.apply(this, arguments)
}

$(document).ready(function() {
  equalheight(".product_category_list article");
  equalheight(".productcard header");
  $(".productcard .image img").lazyLoadXT();

  var timeoutQSearch = 0;

  $("#quicksearch").on(" paste keyup", function(e) {
    if ($(this).val().length > 3) {
      e.preventDefault();
      clearTimeout(timeoutQSearch);
      timeoutQSearch = setTimeout(
        $.post(
          "/store/quicksearch/",
          {
            searchquery: $("#quicksearch").val()
          },
          function(d) {
            $("#quicksearch-result").html(d);
            $("#ajax_search").slideDown();
          }
        ),
        500
      );
    } else {
      $("#ajax_search").slideUp();
    }
  });

  $(document).mouseup(function(e) {
    var container = $(".not_hide_ajax");

    if (
      !container.is(e.target) && // hvis target ikke er container...
      container.has(e.target).length === 0
    ) {
      // ... eller et barn av container
      $("#quicksearch").val("");
      $("#ajax_search").slideUp();
    }
  });
  if ($(".videocontainer video").length > 0) {
    setTimeout(function() {
      scaleVideoContainer();
      initBannerVideoSize(".videocontainer video");
    }, 1000);
    $(window).on("resize", function() {
      scaleVideoContainer();
      scaleBannerVideoSize(".videocontainer video");
    });
  }

  if ($(".product-details .description iframe").length > 0) {
    var iframes = $(".product-details .description iframe");
    var key = /www.youtube.com/;
    for (var i = 0; i != iframes.length; ++i) {
      var match = iframes[i].src.search(key);
      if (match != -1) {
        $(iframes[i]).wrap('<div class="video-container"></div>');
      }
    }
  }
  $(".filters_toggle").on("click touchstart", function(event) {
    event.preventDefault();
    $(this).text(
      $(this).text() == "Vis filter" ? "Skjul filter" : "Vis filter"
    );
    $(this)
      .next("#accordion")
      .slideToggle();
  });
  $(".filters_toggle_bottom").on("click touchstart", function(event) {
    event.preventDefault();
    var scrolloffset = $("#accordion").offset();
    $("html, body")
      .delay(200)
      .animate({ scrollTop: scrolloffset.top - 70 }, 200);
    $(".filters_toggle").text(
      $(this).text() == "Vis filter" ? "Skjul filter" : "Vis filter"
    );
    $(this)
      .parent("#accordion")
      .slideToggle();
  });

  $(".accessibility").on("click", function(e) {
    e.preventDefault();
    if ($(this).hasClass("visible-xs")) {
      $(".navbar-toggle.collapsed").trigger("click");
    }
    var target = $(this).attr("href");
    var scrolloffset = $(target).offset();
    $("html, body")
      .delay(200)
      .animate({ scrollTop: scrolloffset.top }, 500, function() {
        $(target).show();
        $(target).focus();
      });
  });
});
$(function() {
  $(".dynamicform .row").click(function(e) {
    $(this).addClass("rowfloat");
    $(this)
      .children("input")
      .focus();
  });
  $(".dynamicform .row").bind("touchend", function(e) {
    $(this).addClass("rowfloat");
    $(this)
      .children("input")
      .focus();
  });
  $(".dynamicform input, .dynamicform textarea").blur(function(e) {
    if (!$(this).val()) {
      $(this)
        .parent()
        .removeClass("rowfloat");
    }
  });
  $(".dynamicform input, .dynamicform textarea").focus(function(e) {
    if ($(this).val().length >= 0) {
      $(this)
        .parent()
        .addClass("rowfloat");
    }
  });
  $("#contact_form input[required],#contact_form textarea[required]").blur(
    function() {
      var valOk = true;
      $(this)
        .siblings("label")
        .find("em")
        .html("");
      if (!$(this).val()) {
        valOk = false;
        $(this)
          .siblings("label")
          .find("em")
          .html("Husk å fylle ut felt");
      }

      if ($(this).val() && $(this).attr("id") == "email-field") {
        if (!validateEmail($(this).val())) {
          valOk = false;
          $(this)
            .siblings("label")
            .find("em")
            .html("Sjekk epostadressen");
        }
      }

      if (!valOk) {
        $(this).css("background", "#f8cdcd");
        $(this)
          .parent()
          .css("border", "1px solid #e1e1e1");
      } else {
        $(this).css("background", "#ffffff");
        $(this)
          .parent()
          .css("border-bottom", "3px solid #16A7D1");
      }
    }
  );

  $("#contact_form input#phone-field").blur(function() {
    if ($(this).val()) {
      var valOk = true;

      if ($(this).val().length < 8) {
        valOk = false;
      }
      if (valOk) {
        $(this).css("background", "#ffffff");
        $(this)
          .parent()
          .css("border-bottom", "3px solid #16A7D1");
        $(this)
          .siblings("label")
          .find("em")
          .html("");
      } else {
        $(this).css("background", "#f8cdcd");
        $(this)
          .parent()
          .css("border", "1px solid #e1e1e1");
        $(this)
          .siblings("label")
          .find("em")
          .html(" - Norske nummer har minimum 8 siffer");
      }
    } else {
      $(this).css("background", "#ffffff");
      $(this)
        .parent()
        .css("border", "1px solid #e1e1e1");
      $(this)
        .siblings("label")
        .find("em")
        .html("");
    }
  });

  $("#contact_form").submit(function(e) {
    e.preventDefault();
    var self = this;
    $.ajax({
      url: "/store/send_contact_ajax/",
      data: $(self).serialize(),
      dataType: "json",
      type: "POST",
      success: function(data) {
        if (data.status == 1) {
          if (data.errors[0]) {
            $("#name-field").css("background", "#f8cdcd");
            $("#name-field").focus();
            $("#name-field")
              .siblings("label")
              .find("em")
              .html("Husk å fylle ut navn");
          } else {
            $("#name-field").css("background", "#fff");
            $("#name-field")
              .siblings("label")
              .find("em")
              .html("");
          }
          if (data.errors[1]) {
            $("#email-field").css("background", "#f8cdcd");
            $("#email-field").focus();
            $("#email-field")
              .siblings("label")
              .find("em")
              .html("Husk å fylle ut e-postadressen");
          } else {
            $("#email-field").css("background", "#fff");
            $("#email-field")
              .siblings("label")
              .find("em")
              .html("");
          }

          if (data.errors[3]) {
            $("#field-3").css("background", "#f8cdcd");
            $("#field-3")
              .siblings("label")
              .find("em")
              .html("Husk å skrive en melding");
          } else {
            $("#field-3").css("background", "#fff");
            $("#field-3")
              .siblings("label")
              .find("em")
              .html("");
          }
        } else {
          $("#contact_form").hide();
          $("#message").html(
            '<h3>Takk for at du tok kontakt.</h3><p>&nbsp;</p><p style="text-align:center">Vi vil snarlig kontakte deg.</p>'
          );
        }
      }
    });
  });

  $(".newsletter_signup").submit(function(e) {
    e.preventDefault();
    var self = this;
    $.ajax({
      url: "/store/newsletter_subscribe/",
      data: $(self).serialize(),
      dataType: "json",
      type: "POST",
      success: function(data) {
        if (data.status == 1) {
          $(self)
            .siblings(".msg")
            .html("<h3>" + data.msg + "</h3>");
          $(self)
            .find("input.form-control")
            .css("border", "2px solid red;");
        } else {
          $(self)
            .siblings(".msg")
            .html("<h3>" + data.msg + "</h3>");
          $(self).css("display", "none");
        }
      }
    });
  });
});

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

$(window).on('load', function() {
  equalheight(".product_category_list article");
  equalheight(".news_list article");
  equalheight(".productcard header");
  equalheight(".equalheight");

  setTimeout(function() {
    $(".product_filter").isotope("layout");
  }, 400);
});

$(window).resize(function() {
  equalheight(".product_category_list article");
  equalheight(".news_list article");
  equalheight(".productcard header");
  equalheight(".equalheight");

  setTimeout(function() {
    $(".product_filter").isotope("layout");
  }, 800);
});

function equalheight(container) {
  if ($(window).width() > 767) {
    let currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;

    $(container).each(function(e) {
      $el = $(this);
      $($el).height("auto");
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    });

    $(container).each(function(e) {
      $el = $(this);
      $($el).height(currentTallest);
    });
  } else {
    $(container).height("auto");
  }
}

function debounce(fn, threshold) {
  var timeout;
  return function debounced() {
    if (timeout) {
      clearTimeout(timeout);
    }

    function delayed() {
      fn();
      timeout = null;
    }
    timeout = setTimeout(delayed, threshold || 100);
  };
}
function ariaSelect() {
  $(".panel-body")
    .find("input:radio")
    .each(function() {
      if (this.checked) {
        $(this).attr("aria-checked", "true");
      } else {
        $(this).attr("aria-checked", "false");
      }
    });
}
function manageCheckbox($checkbox) {
  var checkbox = $checkbox[0];
  var filters = [];
  var boxes = $(".filter-check:checked");
  for (var index = 0; index < boxes.length; ++index) {
    filters.push(boxes[index]["value"]);
  }
  var name = $(checkbox).attr("name");

  if (filters.length) {
    location.hash = "filter=" + filters.join(",");
  } else {
    $("input.default").prop("checked");
    removeHash();
  }
}
function removeHash() {
  var scrollV,
    scrollH,
    loc = window.location;

  // Prevent scrolling by storing the page's current scroll offset
  scrollV = document.body.scrollTop;
  scrollH = document.body.scrollLeft;

  loc.hash = "";

  // Restore the scroll offset, should be flicker free
  document.body.scrollTop = scrollV;
  document.body.scrollLeft = scrollH;
}

function setBread(hashes) {
  hashes = hashes.replace(/-/g, " ");
  hashes = hashes.replace(/,/g, ", ");
  hashes = hashes.replace(/oe/g, "ø");
  hashes = hashes.replace(/aa/g, "å");
  hashes = hashes.replace(/ae/g, "æ");
  if (hashes != "") {
    if ($("#hash").length) {
      $("#hash").html(hashes);
    } else {
      $(".breadcrumb ul").append('<li id="hash">' + hashes + "</li>");
    }
  } else {
    $("#hash").remove();
  }
}

window.addEventListener(
  "hashchange",
  function(event) {
    var element = document.getElementById(location.hash.substring(1));

    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }
      element.focus();
    }
  },
  false
);

function checkHash() {
  var loadHash = location.hash.startsWith('#filter')
    ? location.hash.slice(8)
    : ''

  if (loadHash) {
    var hashes = loadHash.split(",").map(function(hash) {
      return decodeURIComponent(hash);
    });
    var c1 = true;
    var c2 = true;

    for (var index = 0; index < hashes.length; ++index) {
      var cbox = $("#" + hashes[index]);
      if (cbox.is(":checked")) {
      } else {
        $("#" + hashes[index]).prop("checked", true);
      }

      $(".filter-option-cat input").each(function() {
        var cat = $(this).val();
        if (cat.includes(hashes[index])) {
          c1 = false;
        }
      });
      $(".filter-option-filter input").each(function() {
        var cat2 = $(this).val();
        if (cat2.includes(hashes[index])) {
          c2 = false;
        }
      });

      var imgsrc = $("span[data-name=" + hashes[index] + "]");

      if ($(imgsrc).length) {
        var defimg = false;
      }
    }
    if (c1) {
      $(".filter-option-cat input.default").trigger("click");
    }
    if (c2) {
      $(".filter-option-filter input.default").trigger("click");
    }
  } else {
    $("input.default").trigger("click");
    $("input.default").attr("checked", "checked");
  }
  if (defimg) {
    $(".colorimage").each(function(index, element) {
      $(this).attr(
        "src",
        $(this)
          .siblings("span")
          .eq(0)
          .attr("data-image")
      );
    });
  } else {
    $(imgsrc).each(function(index, element) {
      $(this)
        .siblings("img.colorimage")
        .attr("src", $(this).attr("data-image"));
    });
  }

  //     var elem = $('.filter-option-cat input.default');
  // 	if ( elem.checked ){console.log('1')};
  // 	if ( $( elem ).prop( "checked" ) ){console.log('2')};
  // 	if ( $( elem ).is( ":checked" ) ){console.log('3')};

  setBread(loadHash);
}
window.addEventListener(
  "popstate",
  function(event) {
    var comboFilter = getHashFilter();

    $container.isotope({
      filter: comboFilter,
      getSortData: {
        name: "[data-url]"
      }
      /*,
        sortBy: "name"*/
    });

    equalheight(".item .content");
    checkHash();
  },
  false
);
checkHash();
ariaSelect();
function getHashFilter() {
  var hash = location.hash.startsWith('#filter')
    ? location.hash.slice(8)
    : null

  if (hash) {
    var convhash = hash.split(",").map(function(hash) {
      return decodeURIComponent(hash);
    });
    //var ret = "." + convhash.join(", ."); // ELLER! Denne linjen gjør at filteret viser produkter som er i kategori ELLER filter. Vil aldri få 0 treff.
    var ret = "." + convhash.join("."); // OG! Denne linjen gjør at filteret viser produkter som er i kategori OG filter. Da kan man få 0 treff.
    return ret;
  }
}
var $container = $(".product_filter");
var loadedFilter = getHashFilter();

$container.isotope({
  itemSelector: ".item",
  getSortData: {
    name: "[data-url]"
  },
  filter: loadedFilter /*,
	    sortBy: "name"*/
});

if (location.hash) {
  setTimeout(function() {
    window.scrollTo(0, 0);
  }, 0);
}

$(".filters").on("change", function(jQEvent) {
  jQEvent.preventDefault();
  var $checkbox = $(jQEvent.target);
  manageCheckbox($checkbox);
  ariaSelect();

  var comboFilter = getHashFilter();

  $container.isotope({
    filter: comboFilter,
    getSortData: {
      name: "[data-url]"
    } /*,
	        sortBy: "name"*/
  });

  equalheight(".item .content");
  checkHash();
  var scrolloffset = $(".products-grid").offset();
  $(".products-grid").focus();
  $("html, body")
    .delay(200)
    .animate({ scrollTop: scrolloffset.top - 20 }, 500);
});
$(".filter-option li.rem").each(function(index, element) {
  var keyword = $(this)
    .find("input:checkbox, input:radio")
    .val();
  if (!$(".product_filter .item").hasClass(keyword)) {
    $(this).hide();
  }
});
function cookieWarning() {
  $("#cookieAccept").on("click", function() {});
}
$(document).ready(function() {
  $("a.zoom").zoom();
  $(".jslinks a").click(function(e) {
    e.preventDefault();
    var href = $(this).attr("href");
    var id = "#a" + href.replace(/\//g, "");
    var scrolloffset = $(id).offset();
    $("html, body")
      .delay(200)
      .animate(
        { scrollTop: scrolloffset.top },
        scrolloffset.top / 5 + 300 - scrolloffset.top / 10
      );
  });
  /*
    if($.cookie("cookiewarning") != "accepted"){
		$('#cookiewarning').slideDown('slow', function() {});
	}
	$('#cookieAccept').on('click',function(){
		$('#cookiewarning').slideUp('slow', function(){
			$.cookie("cookiewarning", "accepted", { expires: 1000,  path: '/' });
		});
    });
    */

  $(".quickadd").on("click", function() {
    var addItems = parseInt($(this).attr("data-items"), 10);
    var existingItems = parseInt($("#no_of_entries").val(), 10);
    if (existingItems == 1) {
      $("#no_of_entries").val(addItems);
    } else {
      $("#no_of_entries").val(existingItems + addItems);
    }
  });
});

function throttle(f, delay) {
  var timer = null;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = window.setTimeout(function() {
      f.apply(context, args);
    }, delay || 500);
  };
}

/** Reusable Functions **/
/********************************************************************/

function scaleVideoContainer() {
  var height = $(".videocontainer").height();
  var unitHeight = parseInt(height) + "px";
  $(".categoryimage").css("height", unitHeight);
}

function initBannerVideoSize(element) {
  $(element).fadeIn();
  $(element).each(function() {
    $(this).data("height", $(this).height());
    $(this).data("width", $(this).width());
    scaleBannerVideoSize($(this));
  });
}

function scaleBannerVideoSize(element) {
  var windowWidth = $(".videocontainer").width(),
    windowHeight = $(".videocontainer").height(),
    videoWidth,
    videoHeight;

  $(element).each(function() {
    var videoAspectRatio = $(this).data("height") / $(this).data("width"),
      windowAspectRatio = windowHeight / windowWidth;

    if (videoAspectRatio > windowAspectRatio) {
      videoWidth = windowWidth;
      videoHeight = videoWidth * videoAspectRatio;
      $(this).css({ top: -(videoHeight - windowHeight) / 2 + "px", left: 0 });
    } else {
      videoHeight = windowHeight;
      videoWidth = videoHeight / videoAspectRatio;
      $(this).css({ top: 0, left: -(videoWidth - windowWidth) / 2 + "px" });
    }

    $(this)
      .width(videoWidth)
      .height(videoHeight);
    $(this).data("height", $(this).videoHeight);
    $(this).data("width", $(this).videoWidth);
  });
}

$(".product-image-gallery").owlCarousel({
  items: 1
});

// 1) ASSIGN EACH 'DOT' A NUMBER
dotcount = 1;

$('.owl-dot').each(function () {
  $(this).addClass('dotnumber' + dotcount);
  $(this).addClass('col-xs-4 col-sm-3');
  $(this).attr('data-info', dotcount);
  dotcount = dotcount + 1;
});

// 2) ASSIGN EACH 'SLIDE' A NUMBER
slidecount = 1;

$('.owl-item').not('.cloned').each(function () {
  $(this).addClass('slidenumber' + slidecount);
  slidecount = slidecount + 1;
});

// SYNC THE SLIDE NUMBER IMG TO ITS DOT COUNTERPART (E.G SLIDE 1 IMG TO DOT 1 BACKGROUND-IMAGE)
$('.owl-dot').each(function () {
  grab = $(this).data('info');
  slidegrab = $('.slidenumber' + grab + ' img').attr('src');
  $(this).children("span").css("background-image", "url(" + slidegrab + ")");

});

//Reclamation form
$("#reclamation_form select[required]").blur(function() {
  var valOk = true;
  if (!$(this).val()) {
    valOk = false;
    $(this)
      .siblings("p")
      .find("em")
      .html("Husk å fylle ut felt");
  }
  if (!valOk) {
    $(this).css("background", "#f8cdcd");
    $(this)
      .parent()
      .css("border", "1px solid #e1e1e1");
  } else {
    $(this).css("background", "#ffffff");
    $(this)
      .parent()
      .css("border-bottom", "3px solid #16A7D1");
      $(this)
      .siblings("p")
      .find("em")
      .html("");
  }
});

$("#reclamation_form input[required],#reclamation_form textarea[required]").blur(
  function() {
    var valOk = true;
    $(this)
      .siblings("label")
      .find("em")
      .html("");
    if (!$(this).val()) {
      valOk = false;
      $(this)
        .siblings("label")
        .find("em")
        .html("Husk å fylle ut felt");
    }

    if ($(this).val() && $(this).attr("id") == "email-field") {
      if (!validateEmail($(this).val())) {
        valOk = false;
        $(this)
          .siblings("label")
          .find("em")
          .html("Sjekk epostadressen");
      }
    }

    if (!valOk) {
      $(this).css("background", "#f8cdcd");
      $(this)
        .parent()
        .css("border", "1px solid #e1e1e1");
    } else {
      $(this).css("background", "#ffffff");
      $(this)
        .parent()
        .css("border-bottom", "3px solid #16A7D1");
    }
  }
);

var fileContent = null
var fileName = null

$('#file-field').on('change', function(e) {
  var file = e.target.files[0]
  var reader = new FileReader()

  reader.onload = function(e) {
    fileName = file.name
    fileContent = e.target.result
  }

  reader.readAsDataURL(file)
})

$("#reclamation_form").submit(function(e) {
  e.preventDefault();
  var self = this;
  var payload = $(self).serialize();

  if (fileName && fileContent) {
    payload += "&fileName=" + fileName + "&fileContent=" + fileContent
  }

  console.log(payload)

  $.ajax({
    url: "/store/send_reclamation_ajax/",
    data: payload,
    dataType: "json",
    type: "POST",
    error: function(data) {
      console.log("error: ", data);
    },
    success: function(data) {
      console.log("status: " + data.status);
      if (data.status == 1) {
        console.log("fail?");
        if (data.errors[0]) {
          $("#organization-field").css("background", "#f8cdcd");
          $("#organization-field").focus();
          $("#organization-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 1");
        } else {
          $("#organization-field").css("background", "#fff");
          $("#organization-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[1]) {
          $("#contact_firstname-field").css("background", "#f8cdcd");
          $("#contact_firstname-field").focus();
          $("#contact_firstname-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle feltet");
            console.log("fail 2");
        } else {
          $("#contact_firstname-field").css("background", "#fff");
          $("#contact_firstname-field")
            .siblings("label")
            .find("em")
            .html("");
        }

        if (data.errors[2]) {
          $("#contact_surname-field").css("background", "#f8cdcd");
          $("#contact_surname-field").focus();
          $("#contact_surname-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 3");
        } else {
          $("#contact_surname-field").css("background", "#fff");
          $("#contact_surname-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[3]) {
          $("#email-field").css("background", "#f8cdcd");
          $("#email-field").focus();
          $("#email-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 4");
        } else {
          $("#email-field").css("background", "#fff");
          $("#email-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[4]) {
          $("#phone-field").css("background", "#f8cdcd");
          $("#phone-field").focus();
          $("#phone-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 5");
        } else {
          $("#phone-field").css("background", "#fff");
          $("#phone-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[5]) {
          $("#ordrnr-field").css("background", "#f8cdcd");
          $("#ordrnr-field").focus();
          $("#ordrnr-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 6");
        } else {
          $("#ordrnr-field").css("background", "#fff");
          $("#ordrnr-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[6]) {
          $("#product-field").css("background", "#f8cdcd");
          $("#product-field").focus();
          $("#product-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 7");
        } else {
          $("#product-field").css("background", "#fff");
          $("#product-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[7]) {
          $("#topic-field").css("background", "#f8cdcd");
          $("#topic-field").focus();
          $("#topic-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 8");
        } else {
          $("#topic-field").css("background", "#fff");
          $("#topic-field")
            .siblings("label")
            .find("em")
            .html("");
        }
        if (data.errors[8]) {
          $("#description-field").css("background", "#f8cdcd");
          $("#description-field").focus();
          $("#description-field")
            .siblings("label")
            .find("em")
            .html("Husk å fylle ut feltet");
            console.log("fail 9");
        } else {
          $("#description-field").css("background", "#fff");
          $("#description-field")
            .siblings("label")
            .find("em")
            .html("");
        }
      } else {
        console.log("success?");
        $("#reclamation_form").hide();
        $("#message").html(
          '<h3>Takk for at du tok kontakt.</h3><p>&nbsp;</p><p style="text-align:center">Vi vil snarlig kontakte deg.</p>'
        );
      }
    }
  });
});


$('')